/** Metadata surfaced to the document drawer / viewer (subset of download response). */
export type UprDocumentViewerMeta = {
  fileName?: string;
  documentCreatedAt?: string;
  documentType?: string;
};

/** Fields returned with gzip PDF payload from `GET …/documents/upr-download/…` */
export type UprDownloadResult = UprDocumentViewerMeta & {
  pdfBytes: Uint8Array;
  id?: string;
};

/** HTTP-layer failure from `getUprDownload` (401/403/404 mapped to user-facing messages). */
export class UprDocumentDownloadError extends Error {
  constructor(
    public readonly status: number,
    message: string,
  ) {
    super(message);
    this.name = 'UprDocumentDownloadError';
  }
}
